import React from 'react';
import cx from 'classnames';
import { QuestionCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import { asyncSimpleModal } from '../../lib/common';
import './LabelInfoWithDescription.scss';

const LabelInfoWithDescription = (props) => {
  const { className, label, labelSubInfo, info, description } = props;

  return (
    <div className={cx('label-info', className)}>
      <span className="label">
        <span>{label}</span>
        <QuestionCircleOutlined
          onClick={async () => {
            await asyncSimpleModal(description);
          }}
        />
      </span>
      {!!labelSubInfo && <p className="label-sub-info">{labelSubInfo}</p>}
      <span className="info">{info}</span>
    </div>
  );
};

LabelInfoWithDescription.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  labelSubInfo: PropTypes.string,
  info: PropTypes.string,
  description: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.element,
  }),
};

export default LabelInfoWithDescription;
